// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2MM9b","infoBtn":"quickbooks_infoBtn__2-TPj","formBox":"quickbooks_formBox__3gfei","formFooter":"quickbooks_formFooter__1DQ3V"};